import { Route } from "@angular/router";
import { TransactionTypeEnum } from "./models/transaction";
import stateOfAssetsRoutes from "./state-of-assets-routes";

export const AccountingPaths = {
  Start: "start",
  PeppolStart: "peppol-start",
  Transactions: "verrichtingen",
  ReceiptsAndExpenses: "ontvangsten-uitgaven",
  Receipts: "ontvangsten",
  Expenses: "uitgaven",
  ClaimsAndDebts: "vorderingen-schulden",
  Claims: "vorderingen",
  Debts: "schulden",
  DayReceipts: "dagontvangsten",
  SaleInvoices: "verkoopfacturen",
  PurchaseInvoices: "aankoopfacturen",
  ReceivedCreditNotes: "ontvangen-creditnotas",
  GivenCreditNotes: "uitgereikte-creditnotas",
  TransactionAdd: "inboeken",
  TransactionAddForWorkYear: (workYearId: number | string) => `${workYearId}/inboeken`,
  TransactionAddForWorkYearAndType: (workYearId: number | string, typeId: number | string) =>
    `${workYearId}/inboeken/${typeId}`,
  TransactionAddForType: (typeId: number | string) => `inboeken/${typeId}`,
  TransactionAddForTypePurchaseInvoice: (typeId: number | string) =>
    `inboeken/${typeId}/aankoopfactuur`,
  TransactionAddForTypeSaleInvoice: (typeId: number | string) =>
    `inboeken/${typeId}/verkoopfactuur`,
  TransactionAddForPeppol: (fromPeppolDocumentId: number | string) =>
    `inboeken/peppol/${fromPeppolDocumentId}`,
  TransactionEdit: (transactionId: number | string) => `bewerken/${transactionId}`,
  PeppolInbox: "peppolinbox",
  PeppolRequestList: "peppol-aanvragen",
  PeppolRequestAdd: "peppol-aanvraag/nieuw",
  PeppolRequestEdit: (requestId: number | string) => `peppol-aanvraag/${requestId}`,

  TransferAdd: "geldoverdracht",
  Import: "importeren",
  FinancialStatus: "status",
  Reports: "rapporten",
  AccountList: "rekeningenstelsel",
  AccountEdit: (accountId: number | string) => `rekeningenstelsel/${accountId}`,
  VatTypeSettings: "btw-instellingen",
  InvoiceSettings: "factuur-instellingen",
  FinancialPosts: "geldrekeningen",
  VatDeclration: "btwaangifte",
  Budgets: "begroting",
  BudgetAdd: "begroting/toevoegen",
  BudgetEdit: (budgetId: number | string) => `begroting/bewerken/${budgetId}`,
  BudgetView: (budgetId: number | string) => `begroting/${budgetId}/status`,
  StateOfAssets: "staat-van-vermogen",
  ClientListing: "klantenlisting",
};

export default [
  {
    path: AccountingPaths.Start,
    loadComponent: () => import("./pages/start/start.component").then((c) => c.StartComponent),
    data: {
      breadcrumb: "Start",
      title: "Boekhouding",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.PeppolStart,
    loadComponent: () =>
      import("./pages/peppol-start/peppol-start.component").then((c) => c.PeppolStartComponent),
    data: {
      breadcrumb: "Peppol activeren",
      title: "Peppol activeren",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.Transactions,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Ontvangsten en uitgaven zoeken",
      title: "Ontvangsten en uitgaven zoeken",
      subscriptionTypes: [1, 4],
      isVat: false,
      transactionTypes: [TransactionTypeEnum.ontvangst, TransactionTypeEnum.uitgave],
    },
  },
  {
    path: "list",
    redirectTo: AccountingPaths.Transactions,
  },
  {
    path: AccountingPaths.ReceiptsAndExpenses,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Ontvangsten en uitgaven zoeken",
      title: "Ontvangsten en uitgaven zoeken",
      subscriptionTypes: [1, 4],
      isVat: false,
      transactionTypes: [TransactionTypeEnum.ontvangst, TransactionTypeEnum.uitgave],
    },
  },
  {
    path: AccountingPaths.Receipts,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Ontvangsten zoeken",
      title: "Ontvangsten zoeken",
      subscriptionTypes: [1, 4],
      isVat: false,
      transactionTypes: [TransactionTypeEnum.ontvangst],
    },
  },
  {
    path: AccountingPaths.Expenses,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Uitgaven zoeken",
      title: "Uitgaven zoeken",
      subscriptionTypes: [1, 4],
      isVat: false,
      transactionTypes: [TransactionTypeEnum.uitgave],
    },
  },
  {
    path: AccountingPaths.ClaimsAndDebts,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Vorderingen en schulden zoeken",
      title: "Vorderingen en schulden zoeken",
      subscriptionTypes: [1, 4],
      isVat: false,
      transactionTypes: [TransactionTypeEnum.schuld, TransactionTypeEnum.vordering],
    },
  },
  {
    path: AccountingPaths.Claims,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Vorderingen zoeken",
      title: "Vorderingen zoeken",
      subscriptionTypes: [1, 4, 5],
      isVat: false,
      transactionTypes: [TransactionTypeEnum.vordering],
    },
  },
  {
    path: AccountingPaths.Debts,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Schulden zoeken",
      title: "Schulden zoeken",
      subscriptionTypes: [1, 4, 5],
      isVat: false,
      transactionTypes: [TransactionTypeEnum.schuld],
    },
  },
  {
    path: AccountingPaths.DayReceipts,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Dagontvangstenboek",
      title: "Dagontvangstenboek",
      subscriptionTypes: [1, 4],
      isVat: true,
      transactionTypes: [TransactionTypeEnum.dagOntvangsten],
    },
  },
  {
    path: AccountingPaths.SaleInvoices,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Verkoopfacturen",
      title: "Verkoopfacturen",
      subscriptionTypes: [1, 4, 5],
      isVat: true,
      transactionTypes: [TransactionTypeEnum.vordering],
    },
  },
  {
    path: AccountingPaths.PurchaseInvoices,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Aankoopfacturen",
      title: "Aankoopfacturen",
      subscriptionTypes: [1, 4, 5],
      isVat: true,
      transactionTypes: [TransactionTypeEnum.schuld],
    },
  },
  {
    path: AccountingPaths.ReceivedCreditNotes,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Ontvangen creditnota's",
      title: "Ontvangen creditnota's",
      subscriptionTypes: [1, 4, 5],
      isVat: true,
      transactionTypes: [TransactionTypeEnum.ontvangenCreditnota],
    },
  },
  {
    path: AccountingPaths.GivenCreditNotes,
    loadComponent: () =>
      import("./pages/transactions-list/transactions-list.component").then(
        (c) => c.TransactionsListComponent
      ),
    data: {
      breadcrumb: "Uitgereikte creditnota's",
      title: "Uitgereikte creditnota's",
      subscriptionTypes: [1, 4, 5],
      isVat: true,
      transactionTypes: [TransactionTypeEnum.uitgereikteCreditnota],
    },
  },
  {
    path: AccountingPaths.TransactionAddForWorkYear(":workingyearId"),
    loadComponent: () =>
      import("./pages/transaction-edit/transaction-edit.component").then(
        (c) => c.TransactionEditComponent
      ),
    data: {
      breadcrumb: "Verrichting inboeken",
      title: "Nieuwe verrichting inboeken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.TransactionAddForWorkYearAndType(":workingyearId", ":typeId"),
    loadComponent: () =>
      import("./pages/transaction-edit/transaction-edit.component").then(
        (c) => c.TransactionEditComponent
      ),
    data: {
      breadcrumb: "Verrichting inboeken",
      title: "Nieuwe verrichting inboeken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.TransactionAdd,
    loadComponent: () =>
      import("./pages/transaction-edit/transaction-edit.component").then(
        (c) => c.TransactionEditComponent
      ),
    data: {
      breadcrumb: "Verrichting inboeken",
      title: "Nieuwe verrichting inboeken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.TransactionAddForType(":typeId"),
    loadComponent: () =>
      import("./pages/transaction-edit/transaction-edit.component").then(
        (c) => c.TransactionEditComponent
      ),
    data: {
      breadcrumb: "Verrichting inboeken",
      title: "Nieuwe verrichting inboeken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.TransactionAddForTypePurchaseInvoice(":typeId"),
    loadComponent: () =>
      import("./pages/transaction-edit/transaction-edit.component").then(
        (c) => c.TransactionEditComponent
      ),
    data: {
      breadcrumb: "Aankoopfactuur inboeken",
      title: "Nieuwe aankoopfactuur inboeken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.TransactionAddForTypeSaleInvoice(":typeId"),
    loadComponent: () =>
      import("./pages/transaction-edit/transaction-edit.component").then(
        (c) => c.TransactionEditComponent
      ),
    data: {
      breadcrumb: "Verkoopfactuur inboeken",
      title: "Nieuwe verkoopfactuur inboeken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.TransactionEdit(":id"),
    loadComponent: () =>
      import("./pages/transaction-edit/transaction-edit.component").then(
        (c) => c.TransactionEditComponent
      ),
    data: {
      breadcrumb: "Verrichting inboeken",
      title: "Verrichting bewerken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.TransferAdd,
    loadComponent: () =>
      import("./pages/transfer-add/transfer-add.component").then((c) => c.TransferAddComponent),
    data: {
      breadcrumb: "Geldoverdracht inboeken",
      title: "Nieuwe geldoverdracht inboeken",
    },
  },
  {
    path: AccountingPaths.PeppolInbox,
    loadComponent: () =>
      import("./pages/peppol-inbox/peppol-inbox.component").then((c) => c.PeppolInboxComponent),
    data: {
      breadcrumb: "Peppol-inbox",
      title: "Peppol-inbox",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.TransactionAddForPeppol(":fromPeppolDocumentId"),
    loadComponent: () =>
      import("./pages/transaction-edit/transaction-edit.component").then(
        (c) => c.TransactionEditComponent
      ),
    data: {
      breadcrumb: "Verrichting aanmaken",
      title: "Nieuwe verrichting aanmaken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.PeppolRequestEdit(":id"),
    loadComponent: () =>
      import("./pages/peppol-request-edit/peppol-request-edit.component").then(
        (c) => c.PeppolRequestEditComponent
      ),
    data: {
      breadcrumb: "Peppol aanvraag bewerken",
      title: "Peppol aanvraag bewerken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.Import,
    loadComponent: () =>
      import("./pages/transaction-import/transaction-import.component").then(
        (c) => c.TransactionImportComponent
      ),
    data: {
      breadcrumb: "Verrichtingen importeren",
      title: "Verrichtingen importeren",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.FinancialStatus,
    loadComponent: () =>
      import("./pages/financial-status/financial-status.component").then(
        (c) => c.FinancialStatusComponent
      ),
    data: {
      breadcrumb: "Financiële status",
      title: "Financiële status",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.Reports,
    loadComponent: () =>
      import("./pages/financial-reports/financial-reports.component").then(
        (c) => c.FinancialReportsComponent
      ),
    data: {
      breadcrumb: "Financiële rapporten",
      title: "Financiële rapporten en verslagen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: "reports",
    redirectTo: AccountingPaths.Reports,
  },
  {
    path: AccountingPaths.AccountList,
    loadComponent: () =>
      import("./pages/account-list/account-list.component").then((c) => c.AccountListComponent),
    data: {
      breadcrumb: "Rekeningenstelsel",
      title: "Ontvangsten- en uitgavenrekeningen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.AccountEdit(":id"),
    loadComponent: () =>
      import("./pages/account-list/account-list.component").then((c) => c.AccountListComponent),
    data: {
      breadcrumb: "Rekeningenstelsel",
      title: "Ontvangsten- en uitgavenrekeningen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.VatTypeSettings,
    loadComponent: () =>
      import("./pages/vat-type-edit/vat-type-edit.component").then((c) => c.VatTypeEditComponent),
    data: {
      breadcrumb: "Voorkeuren en instellingen",
      title: "Boekhouding",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.InvoiceSettings,
    loadComponent: () =>
      import("./pages/invoice-settings-edit/invoice-settings-edit.component").then(
        (c) => c.InvoiceSettingsEditComponent
      ),
    data: {
      breadcrumb: "Voorkeuren en instellingen",
      title: "Boekhouding",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.FinancialPosts,
    loadComponent: () =>
      import("./pages/financialpost-list/financialpost-list.component").then(
        (c) => c.FinancialpostListComponent
      ),
    data: {
      breadcrumb: "Geldrekeningen",
      title: "Geldrekeningen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.VatDeclration,
    loadComponent: () =>
      import("./pages/vat-declaration/vat-declaration.component").then(
        (c) => c.VatDeclarationComponent
      ),
    data: {
      breadcrumb: "Btw-aangifte",
      title: "Btw-aangifte",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.Budgets,
    loadComponent: () =>
      import("./pages/budget-list/budget-list.component").then((c) => c.BudgetListComponent),
    data: {
      breadcrumb: "Begroting",
      title: "Begroting",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.BudgetAdd,
    loadComponent: () =>
      import("./pages/budget-edit/budget-edit.component").then((c) => c.BudgetEditComponent),
    data: {
      breadcrumb: "Begroting toevoegen",
      title: "Begroting toevoegen",
      SubscriptionTypeEnum: [1, 4],
    },
  },
  {
    path: AccountingPaths.BudgetEdit(":id"),
    loadComponent: () =>
      import("./pages/budget-edit/budget-edit.component").then((c) => c.BudgetEditComponent),
    data: {
      breadcrumb: "Begroting bewerken",
      title: "Begroting bewerken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.BudgetView(":id"),
    loadComponent: () =>
      import("./pages/budget-view/budget-view.component").then((c) => c.BudgetViewComponent),
    data: {
      breadcrumb: "Begroting bekijken",
      title: "Begroting bekijken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: AccountingPaths.StateOfAssets,
    data: { breadcrumb: "Staat van het Vermogen" },
    children: stateOfAssetsRoutes,
  },
  {
    path: AccountingPaths.PeppolRequestList,
    loadComponent: () =>
      import("./pages/peppol-request-list/peppol-request-list.component").then(
        (c) => c.PeppolRequestListComponent
      ),
    data: {
      breadcrumb: "Peppol Aanvragen",
      title: "Peppol Aanvragen",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.PeppolRequestAdd,
    loadComponent: () =>
      import("./pages/peppol-request-edit/peppol-request-edit.component").then(
        (c) => c.PeppolRequestEditComponent
      ),
    data: {
      breadcrumb: "Nieuwe Peppol aanvraag",
      title: "Nieuwe Peppol aanvraag",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: AccountingPaths.ClientListing,
    loadComponent: () =>
      import("../menu/pages/on-hold/on-hold.component").then((c) => c.OnHoldComponent),
    data: {
      breadcrumb: "Klantenlisting",
      title: "Klantenlisting",
      previousVersionUrl: "https://app.assistonline.eu/dba/#/app/boekhouding/klantenlisting",
      subscriptionTypes: [1, 4],
    },
  },
] satisfies Route[];
